import React from "react";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { responsiveFontSizes, spacing } from "@/utils/responsive";

interface CardProps {
  title: string;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  rightContent?: React.ReactNode;
  sx?: object;
  variant?: "default" | "kpi";
}

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  rightContent,
  sx = {},
  variant = "default",
}) => {
  const theme = useTheme();
  const isKpi = variant === "kpi";

  return (
    <Paper
      elevation={1}
      sx={{
        p: isKpi ? { xs: 1.25, md: 1.75 } : { xs: 2, md: 2.5 },
        borderRadius: 2,
        backgroundColor: "white",
        border: `1px solid ${theme.palette.divider}`,
        height: "100%",
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={isKpi ? 0.5 : 1}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight={600}
            sx={{ fontSize: isKpi ? responsiveFontSizes.sm : responsiveFontSizes.xs, lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="h4"
              fontWeight={800}
              color="primary.dark"
              sx={{
                mt: isKpi ? spacing.xs : spacing.xs,
                fontSize: isKpi ? responsiveFontSizes['3xl'] : responsiveFontSizes.lg,
                lineHeight: 1.15,
                letterSpacing: isKpi ? "-0.2px" : 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {subtitle}
            </Typography>
          )}
          {children}
        </Box>
        {rightContent && (
          <Box sx={{ minWidth: isKpi ? 100 : 120, mt: { xs: 2, sm: 0 } }}>{rightContent}</Box>
        )}
      </Stack>
    </Paper>
  );
};

export default Card; 